import { render, staticRenderFns } from "./OrgaDialog.vue?vue&type=template&id=e46bd8f6&"
import script from "./OrgaDialog.vue?vue&type=script&lang=js&"
export * from "./OrgaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports